module.exports = __webpack_public_path__ + "static/media/avatar-1.cbf9c83a.jpg";